export default "__VITE_ASSET__BfowAisC__"